import { render, staticRenderFns } from "./ManageBusinessProfile.vue?vue&type=template&id=ebbba7e0"
import script from "./ManageBusinessProfile.vue?vue&type=script&lang=js"
export * from "./ManageBusinessProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports